export enum sortingOrder {
	ASCENDING = 'ascending',
	DESCENDING = 'descending'
}
